import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState } from 'react'
import { categorizeIngredients } from '../util/categorize';
import { useDispatch } from 'react-redux';
import { addItemToCart } from '../State/Cart/Action';
import { useNavigate } from 'react-router-dom';
const demo=[
    {
        category: "Nuts & seeds",
        ingredients:["Cashews"]
    },
    {
        category: "Protein",
        ingredients:["Protein"]
        
    }, 
    {
        category: "Protein",
        ingredients:["Ground beef","Bacon strips"]
    }
]
const MenuCard = ({item}) => {
    const navigate=useNavigate();
    const dispatch=useDispatch();
    const [selectedIngredients, setSelectedIngredients]=useState([]);
    const handleCheckBoxChange=(itemName)=>{
        console.log(itemName)
        if(selectedIngredients.includes(itemName)){
            setSelectedIngredients(selectedIngredients.filter((item)=>item!=itemName))
        }
        else{
            selectedIngredients([...selectedIngredients,itemName])
        }

    }
    const handleAddItemToCart=()=>{
        e.preventDefault()
        const reqData = {
            token:localStorage.getItem("jwt"),
        cartItem:{
            foodId:item.id,
            quantity:1,
            ingredients:selectedIngredients,
        },
        }
        dispatch(addItemToCart(reqData));
        console.log("req Data",reqData)
      
    }
  return (
    <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
         <div className='lg:flex items=center justify-between'>
            <div className='lg:flex items=center lg:gap-5'>
                <img className='w-[7rem] h=[7rem] object-cover' 
                // src={item.images[0]}
                src="https://images.pexels.com/photos/2122294/pexels-photo-2122294.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                alt="menu item image"/>

                <div className='space-y-1 lg:space-y-5 lg:max-w-2xl'>
                    <p className='font-semibold text-xl'>
                        {/* {item.name} */} Burger
                        </p>
                    <p>
                        {/* {item.price} */} 20
                        </p>
                    <p className='text-gray-400'>
                        {/* {item.description} */} burger is a 
                        </p>
                </div>
            </div>

         </div>
        </AccordionSummary>
        <AccordionDetails>
            {/* <form onSubmit={handleAddItemToCart} >
                <div className='flex gap-5 flex-wrap'>
                    {
                        Object.keys(categorizeIngredients(item.ingredients)).map((category)=>
                        <div>
                            <p>
                                {category}
                            </p>
                            <FormGroup>
                        {
                           categorizeIngredients(item.ingredients)[category].map((item)=>
                            
                                <FormControlLabel key={item.id} control={<Checkbox onChange={()=>{handleCheckBoxChange(item.name)}}  />} label={item.name} />
                            )
                        }
                         </FormGroup>
                        </div>
                    
                        )
                    }
                </div>
                <div className='pt-5'>
                    <Button type="submit" variant="contained" disabled={false}>{true?"Add to Cart":"Out of Stock"}</Button>
                </div>
            </form> */}
            <form onSubmit={handleAddItemToCart} >
                <div className='flex gap-5 flex-wrap'>
                    {
                        demo.map((item)=>
                        <div>
                            <p>
                                {item.category}
                            </p>
                            <FormGroup>
                        {
                           item.ingredients.map((item)=>
                            
                                <FormControlLabel key={item.id} control={<Checkbox onChange={()=>{handleCheckBoxChange(item)}}  />} label={item} />
                            )
                        }
                         </FormGroup>
                        </div>
                    
                        )
                    }
                </div>
                <div className='pt-5'>
                    <Button  onClick={()=>navigate("/cart")}  type="submit" variant="contained" disabled={false}> {true?"Add to Cart":"Out of Stock"}</Button>
                </div>
            </form>
             
         </AccordionDetails>
      </Accordion>
    // <div>
    //     Hi
    // </div>
  )
}

export default MenuCard